/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Cmp_About_VisitInputs */

const en_cmp_about_visit = /** @type {(inputs: Cmp_About_VisitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Visit ${i?.name} →`)
};

const id_cmp_about_visit = /** @type {(inputs: Cmp_About_VisitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kunjungi ${i?.name} →`)
};

/**
* | output |
* | --- |
* | "Visit {name} →" |
*
* @param {Cmp_About_VisitInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_about_visit = /** @type {((inputs: Cmp_About_VisitInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_About_VisitInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_about_visit(inputs)
	return en_cmp_about_visit(inputs)
});